import { useEffect, useState } from "react";

import Hero from "./Hero/Hero";
import Landing from "./Landing/Landing";

// fetching data
import useFetch from "Hooks/useFetch";
import LoadingScreen from "Components/RequestHandler/LoadingScreen";

import IsError from "Components/RequestHandler/IsError";
import { useParams } from "react-router-dom";
const JobDetails = () => {
  const { slug } = useParams();

  const [data, setData] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const { fetchData, error } = useFetch();

  const getData = async () => {
    setIsLoading(true);
    setIsError(false);

    try {
      const data = await fetchData(`career/${slug}`);
      setData(data);
    } catch (error) {
      setIsError(true);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getData();
  }, [slug]);

  if (isLoading) return <LoadingScreen />;
  if (error || isError) return <IsError />;
  if (data) {
    return (
      <main>
        <Hero jobTitle={data?.job_title} />
        <Landing slug={slug} data={data} />
      </main>
    );
  }
};

export default JobDetails;
